<div class="min-h-[calc(100vh-64px)] bg-neutral-50 p-4 md:p-6 dark:bg-neutral-900">
  <!-- Header -->
  <div class="mb-4 md:mb-6">
    <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <div class="flex flex-col gap-1">
        <h2 class="text-lg md:text-xl font-bold text-neutral-900 dark:text-white">Detalhe do Pedido</h2>
        <div class="flex items-center gap-3 flex-wrap">
          <span class="font-mono text-sm text-neutral-600 dark:text-neutral-400">{{ routeOrderId() || '-' }}</span>

          @if (details()?.status) {
            <span class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-extrabold uppercase tracking-wide"
              [ngClass]="{
                'border-green-200 bg-green-50 text-green-700 dark:border-green-900/50 dark:bg-green-900/20 dark:text-green-400': details()?.status === 'invoiced',
                'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900/50 dark:bg-blue-900/20 dark:text-blue-400': details()?.status === 'handling' || details()?.status === 'ready-for-handling',
                'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-400': details()?.status === 'payment-pending' || details()?.status === 'waiting-for-sellers-confirmation',
                'border-red-200 bg-red-50 text-red-700 dark:border-red-900/50 dark:bg-red-900/20 dark:text-red-400': details()?.status === 'canceled' || details()?.status === 'cancellation-requested',
                'border-neutral-200 bg-neutral-50 text-neutral-700 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-400': details()?.status !== 'invoiced' && details()?.status !== 'handling' && details()?.status !== 'ready-for-handling' && details()?.status !== 'payment-pending' && details()?.status !== 'waiting-for-sellers-confirmation' && details()?.status !== 'canceled' && details()?.status !== 'cancellation-requested'
              }"
            >
              {{ details()?.status }}
            </span>
          }

          @if (invoiceText()) {
            <span class="text-xs font-mono text-neutral-500 dark:text-neutral-400">{{ invoiceText() }}</span>
          }
        </div>
      </div>
    </div>

    @if (sucessMsg()) {
      <app-alert type="success" icon="x-circle" class="mt-3">
        {{ sucessMsg() }}
      </app-alert>
    } @else if (errorMsg()) {
      <app-alert type="danger" icon="x-circle" class="mt-3">
        {{ errorMsg() }}
      </app-alert>
    }
  </div>

  @if (loading()) {
    <app-alert type="info" icon="refresh-cw">
      Carregando detalhes do pedido...
    </app-alert>
  }

  @if (details()) {
    <!-- Top grid -->
    <div class="grid grid-cols-1 gap-3 lg:grid-cols-3">
      <!-- Cliente -->
      <section class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800">
        <div class="mb-3 text-[11px] font-extrabold uppercase tracking-wider text-neutral-700 dark:text-neutral-400">
          Cliente
        </div>

        <div class="space-y-2">
          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Pedido</div>
            <div class="text-sm font-mono text-neutral-900 text-right dark:text-white">{{ details()?.orderId }}</div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Criado em</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">{{ details()?.creationDate }}</div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Status</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">{{ details()?.status }}</div>
          </div>

          <div class="my-3 h-px w-full bg-neutral-100 dark:bg-neutral-700"></div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Nome</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">{{ customerName() }}</div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Documento</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">{{ customerDocument() }}</div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Telefone</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">{{ customerPhone() }}</div>
          </div>

        </div>
      </section>

      <!-- Entrega -->
      <section class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800">
        <div class="mb-3 text-[11px] font-extrabold uppercase tracking-wider text-neutral-700 dark:text-neutral-400">
          Entrega
        </div>

        <div class="space-y-2">
          <div class="text-xs text-neutral-500 dark:text-neutral-500">Endereço</div>

          <pre
            class="whitespace-pre-line rounded-xl border border-neutral-100 bg-neutral-50 p-3 text-sm text-neutral-800 dark:border-neutral-700 dark:bg-neutral-900/50 dark:text-neutral-300"
          >{{ addressText() }}</pre>

          <div class="my-3 h-px w-full bg-neutral-100 dark:bg-neutral-700"></div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Sales Channel</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">{{ details()?.salesChannel ?? '-' }}</div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Sellers</div>
            <div class="text-sm text-neutral-900 text-right dark:text-white">
              @if ((details()?.sellers?.length ?? 0) > 0) {
                <div class="flex flex-col items-end gap-1">
                  @for (s of details()?.sellers; track $index) {
                    <span class="inline-flex items-center rounded-full border border-neutral-200 bg-white px-2 py-0.5 text-xs dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-300">
                      {{ s.name ?? s.id ?? '-' }}
                    </span>
                  }
                </div>
              } @else {
                <span class="text-neutral-500 dark:text-neutral-500">-</span>
              }
            </div>
          </div>
        </div>
      </section>

      <!-- Valores -->
      <section class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800">
        <div class="mb-3 text-[11px] font-extrabold uppercase tracking-wider text-neutral-700 dark:text-neutral-400">
          Valores
        </div>

        <div class="space-y-2">
          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Itens</div>
            <div class="text-sm font-mono text-neutral-900 text-right dark:text-white">
              {{ formatCents(totalsVm().items) }}
            </div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Descontos</div>
            <div class="text-sm font-mono text-neutral-900 text-right dark:text-white">
              {{ formatCents(totalsVm().discounts) }}
            </div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Envio</div>
            <div class="text-sm font-mono text-neutral-900 text-right dark:text-white">
              {{ formatCents(totalsVm().shipping) }}
            </div>
          </div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-xs text-neutral-500 dark:text-neutral-500">Tax</div>
            <div class="text-sm font-mono text-neutral-900 text-right dark:text-white">
              {{ formatCents(totalsVm().tax) }}
            </div>
          </div>

          <div class="my-3 h-px w-full bg-neutral-100 dark:bg-neutral-700"></div>

          <div class="flex items-start justify-between gap-4">
            <div class="text-sm font-extrabold text-neutral-900 dark:text-white">Valor final</div>
            <div class="text-base font-extrabold font-mono text-neutral-900 text-right dark:text-white">
              {{ formatCents(totalsVm().final) }}
            </div>
          </div>
        </div>
      </section>
    </div>

    @if (showApprovalWorkflow() && workflowData()) {
      <app-approval-workflow
        [workflow]="workflowData()!"
        [referenceId]="routeOrderId()"
        [canPerformActions]="canPerformWorkflowActions()"
        name="Reprocessamento de Nota Fiscal"
        [description]="'A solicitação de reprocessamento para o pedido ' + (details()?.orderId || '') + ' foi enviada e aguarda aprovação.'"
        (workflowUpdated)="onWorkflowUpdated($event)"
        (workflowCancelled)="onWorkflowCancelled()"
      ></app-approval-workflow>
    }

    <div
      class="mt-3 flex flex-col-reverse"
    >
      <app-order-timeline
        [orderId]="routeOrderId()"
        [occurredEventsInput]="orderTimeline()?.occurredEvents ?? []"
        [expectedEventsInput]="orderTimeline()?.expectedEvents ?? []"
        [timelineLoading]="orderTimelineLoading()"
      ></app-order-timeline>
    <app-order-inconsistencies
      [inconsistencies]="inconsistencies()"
      (reprocessInvoice)="openReprocessModal()"
      [isReprocessingOrder]="isReprocessingOrder()"
      [hasActiveWorkflow]="showApprovalWorkflow()"
    ></app-order-inconsistencies>

    </div>
    <!-- Itens (opcional / diagnóstico) -->
    <section class="mt-3 rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800">
      <div class="mb-3 text-[11px] font-extrabold uppercase tracking-wider text-neutral-700 dark:text-neutral-400">
        Itens
      </div>

      @if ((details()?.items?.length ?? 0) === 0) {
        <div class="text-sm text-neutral-600 dark:text-neutral-400">Sem itens.</div>
      } @else {
        <div class="overflow-x-auto">
          <div class="min-w-[760px]">
            <div class="grid grid-cols-4 gap-3 border-b border-neutral-100 pb-2 text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:border-neutral-700 dark:text-neutral-500">
              <div>Produto</div>
              <div class="text-right">Qtd</div>
              <div class="text-right">Preço</div>
              <div class="text-right">Selling</div>
            </div>

            <div class="divide-y divide-neutral-100 dark:divide-neutral-700">
              @for (p of details()?.items; track $index) {
                <div class="grid grid-cols-4 gap-3 py-3">
                  <div class="min-w-0">
                    <div class="truncate text-sm font-semibold text-neutral-900 dark:text-white">{{ p.name ?? '-' }}</div>
                    <div class="mt-1 text-xs font-mono text-neutral-500 dark:text-neutral-500">productId: {{ p.productId ?? '-' }}</div>
                  </div>

                  <div class="text-right text-sm font-mono text-neutral-900 dark:text-white">{{ p.quantity }}</div>
                  <div class="text-right text-sm font-mono text-neutral-900 dark:text-white">{{ formatCents(p.price ?? 0) }}</div>
                  <div class="text-right text-sm font-mono text-neutral-900 dark:text-white">{{ formatCents(p.sellingPrice ?? 0) }}</div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </section>
  }

</div>

<app-modal #reprocessModal title="Confirmar reprocessamento" class="min-w-[900px]">
  <div class="max-h-[70vh] overflow-auto space-y-4 max-w-[1000px] mx-auto">
    <p class="text-sm text-neutral-600 dark:text-neutral-400">
      A solicitação será enviada para processamento e será executada somente após a abertura de um incidente e as devidas aprovações.
    </p>

    <input
      type="text"
      maxlength="10"
      [(ngModel)]="callNumber"
      class="flex-1 border border-neutral-300 dark:border-neutral-700 rounded px-2 py-1 text-sm bg-white dark:bg-neutral-900"
      placeholder="N chamado"
      [ngClass]="callNumber.length === 10 ? 'border-green-500' : 'border-neutral-300'"
    />

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <h3 class="text-sm font-semibold mb-1">Dfdl order</h3>
        <pre class="text-xs bg-neutral-100 dark:bg-neutral-800 p-2 rounded max-h-64 overflow-auto">
{{ simulateDfdlOrder() }}
        </pre>
      </div>
      @if (simulateDfdlBilling()) {
        <div>
          <h3 class="text-sm font-semibold mb-1">Dfdl billing</h3>
          <pre class="text-xs bg-neutral-100 dark:bg-neutral-800 p-2 rounded max-h-64 overflow-auto">
{{ simulateDfdlBilling() }}
        </pre>
        </div>

      }


    </div>

    <div class="flex justify-end gap-3">
      <app-button
        color="neutral" (buttonClick)="reprocessModal.closeDialog()">Cancelar
      </app-button>
      <app-button
        color="success"
        [disabled]="createWorkflowLoading() || callNumber.length !== 10"
        (buttonClick)="confirmReprocess()"
      >
        @if (!createWorkflowLoading()) {
          Solicitar workflow
        } @else {
          <span class="flex items-center gap-2">
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            Criando…
          </span>
        }
      </app-button>

    </div>
  </div>
</app-modal>

